import { render, staticRenderFns } from "./RegularPickup.vue?vue&type=template&id=7be513d3&"
import script from "./RegularPickup.vue?vue&type=script&lang=js&"
export * from "./RegularPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports